import { render, staticRenderFns } from "./ModernAccountMenu.vue?vue&type=template&id=6e8a9bb5&"
import script from "./ModernAccountMenu.vue?vue&type=script&lang=js&"
export * from "./ModernAccountMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports